import PopoverPosition from './mixins/popover-position';
import Em from 'ember';
export default Em.Component.extend(PopoverPosition, {
  classNames: ['ic-popup', 'ic-popup-above', 'ic-popup-short', 'is-light-theme'],
  didInsertElement() {
    this._super(...arguments);
    this.setupEditorDimensions();
  },
  iconClass: Em.computed('widget.name', function () {
    if (this.get('widget.name') === 'logo') {
      return 'i o__cloud-upload o__by-text';
    }
    return 'i o__edit o__by-text';
  }),
  attributeBindings: ['style'],
  arrowHeight: 5,
  click() {
    this.popoverWasClicked();
  }
});